import React from "react";
import { Chart as ChartJS } from "chart.js/auto";
import { Bar } from "react-chartjs-2";

const GroupBarChart = ({ graphData }) => {
  const netCashFlowWTF = parseInt(graphData?.net_cash_flow_wtf) || 0;
  const netCashFlowGym = parseInt(graphData?.net_cash_flow_gym) || 0;
  const totalGymNetRevenue =
    Math.abs(Math.round(netCashFlowGym + netCashFlowWTF)) || 0;

  const totalGymGrossRevenue =
    Math.abs(
      Math.round(
        graphData?.data?.[0]?.gross_revenue || graphData?.data?.gross_revenue
      )
    ) || 0;

  const addonGrossRevenue =
    Math.round(
      parseInt(
        graphData?.cash_flow_other_membership?.share_details?.[0]?.gross_revenue
      )
    ) || 0;

  const addonNetRevenue =
    Math.round(
      parseInt(
        graphData?.cash_flow_other_membership?.share_details?.[0]?.net_revenue
      )
    ) || 0;

  const ptGrossRevenue =
    Math.round(
      parseInt(
        graphData?.cash_flow_other_membership?.share_details?.[1]?.gross_revenue
      )
    ) || 0;

  const ptNetRevenue =
    Math.round(
      parseInt(
        graphData?.cash_flow_other_membership?.share_details?.[1]?.net_revenue
      )
    ) || 0;

  const nutritionGrossRevenue =
    Math.round(
      parseInt(
        graphData?.cash_flow_other_membership?.share_details?.[2]?.gross_revenue
      )
    ) || 0;

  const nutritionNetRevenue =
    Math.round(
      parseInt(
        graphData?.cash_flow_other_membership?.share_details?.[2]?.net_revenue
      )
    ) || 0;

  const labels = ["Gym Membership", "Nutrition", "PT", "Addon"];

  const options = {
    gridLines: false,

    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: false,
        grid: {
          display: false,
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Net revenue",
        data: [
          totalGymNetRevenue,
          nutritionNetRevenue,
          ptNetRevenue,
          addonNetRevenue,
        ],
        backgroundColor: "#3D6FD2",
        color: "#FFFFFF",
      },
      {
        label: "Gross revenue",
        data: [
          totalGymGrossRevenue,
          nutritionGrossRevenue,
          ptGrossRevenue,
          addonGrossRevenue,
        ],
        backgroundColor: "#FF8F6B",
        color: "#FFFFFF",
      },
    ],
  };

  return (
    <div className="container">
      {graphData ? (
        <div>
          <Bar height={100} data={data} options={options} />
        </div>
      ) : (
        <span>No Data Found!</span>
      )}
    </div>
  );
};

export default GroupBarChart;
